import { FeatureFlagKey } from "core/feature-flags";
import { useFeatureFlag } from "core/hooks/useFeatureFlag";
import { PropsWithChildren, ReactNode } from "react";

export interface IFeatureFlagProps {
  flagKey: FeatureFlagKey
  fallback?: ReactNode
}

export function FeatureFlag({
  children,
  flagKey,
  fallback
}: PropsWithChildren<IFeatureFlagProps>) {
  const isEnabled = useFeatureFlag(flagKey);

  if (isEnabled)
    return children;

  return fallback ?? null;
}